module.exports = __webpack_public_path__ + "img/constant-house.b7bfc776.jpg";